import { HttpApiClient, HttpClient, } from "@effect/platform";
import { Effect, Schema as S } from "effect";
import { api, Unauthorized } from "./index.js";
export { RISK_TEMPLATE_MEASURE_LINK_BATCH_SIZE } from "./index.js";
export { INSPECTION_LOCATION_MANAGER_BATCH_SIZE } from "./index.js";
export { CalendarDateFromString, InstantFromString } from "./temporal.js";
/**
 * Derived typed client for the /web/v1 contract — apps/web (and bridge int
 * tests) never raw-fetch share state. Session auth rides transformClient
 * (e.g. inject `Authorization: Bearer …` from the auth store); the
 * principal middleware is server-internal and never appears here.
 */
export const makeClient = (baseUrl, options) => HttpApiClient.make(api, {
    baseUrl,
    ...(options?.transformClient
        ? { transformClient: options.transformClient }
        : {}),
});
/**
 * The signed-in client for the /web/v1 contract. A rejected session is
 * consumed here, once, for every endpoint: `onUnauthorized` runs and the call
 * never completes, so no leaf can observe `Unauthorized` and its type is
 * removed from the error channel callers see.
 */
export const makeSessionClient = (baseUrl, options) => 
// The one assertion: the library types the client from the contract, and
// `transformResponse` cannot change that type. Every endpoint effect goes
// through the hook, which turns `Unauthorized` into `Effect.never`, so the
// narrowed error channel is exactly what the runtime can produce.
HttpApiClient.make(api, {
    baseUrl,
    // Any 401 ends the session, whatever its body: a gateway or the legacy
    // auth layer can reject a session with a body that is not the contract's
    // `Unauthorized`, which would otherwise surface as a decode error.
    transformClient: (client) => HttpClient.transformResponse(options.transformClient ? options.transformClient(client) : client, Effect.flatMap((response) => response.status === 401
        ? Effect.zipRight(options.onUnauthorized, Effect.never)
        : Effect.succeed(response))),
    transformResponse: (effect) => {
        const authenticated = Effect.catchIf(effect, S.is(Unauthorized), () => Effect.zipRight(options.onUnauthorized, Effect.never));
        return options.transformResponse
            ? options.transformResponse(authenticated)
            : authenticated;
    },
});
//# sourceMappingURL=client.js.map